// Local translations
export const T = {
  en_GB: {
    clients: "Clients",
  },
  nb_NO: {
    clients: "Kunder",
  },
} as const;
